import { useState } from "react";
import { Copy, Check } from "lucide-react";

export const CmsPathChip = ({ label = "CMS Path", path }) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(path);
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch {
      /* ignore */
    }
  };
  return (
    <div
      className="inline-flex flex-wrap items-stretch font-mono text-xs brut-border brut-shadow-sm bg-background"
      data-testid="cms-path-chip"
    >
      <span className="px-3 py-2 bg-foreground text-background font-bold uppercase tracking-widest">
        {label}
      </span>
      <span className="px-3 py-2 break-all">{path}</span>
      <button
        onClick={handleCopy}
        aria-label="Copy CMS path"
        data-testid="cms-path-copy-button"
        className="px-3 py-2 border-l-2 border-foreground hover:bg-brut-yellow transition-colors flex items-center gap-1"
      >
        {copied ? (
          <>
            <Check className="w-3.5 h-3.5" strokeWidth={3} />
            <span className="hidden sm:inline">Copied</span>
          </>
        ) : (
          <>
            <Copy className="w-3.5 h-3.5" strokeWidth={2.5} />
            <span className="hidden sm:inline">Copy</span>
          </>
        )}
      </button>
    </div>
  );
};
